import React from 'react';
import PropTypes from 'prop-types';
import LoginPage from '../../../common/loginPage';
import { getGamblingCompliance } from '../../../common/gamblingCompliance';

export const IframeLoginPage = ({ match, containsTermsInLoginIframe }) => {
    const gamblingCompliance = getGamblingCompliance(match.params.feed)
    return (
        <div className="bs-horizontalSlider__element bs-drawer__iframeContainer">
            <div className="bs-drawer__content">
                <LoginPage match={match} />
                {
                    !containsTermsInLoginIframe ? (gamblingCompliance) : null
                }
            </div>
        </div>
    )
}

IframeLoginPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            bookmaker: PropTypes.string,
        }),
    }).isRequired,
    containsTermsInLoginIframe: PropTypes.bool.isRequired,
}

export default IframeLoginPage



// WEBPACK FOOTER //
// /src/js/drawer/components/LoginPage/IframeLoginPage.jsx